var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MaskLayer',[_c('b-spinner',{attrs:{"variant":"success","label":"Spinning"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }